export default {
    path: 'filter',
    component: () => import('../Filter.vue'),
    children: [
        {
            path: '',
            name: 'Danh sách bộ lọc',
            component: () => import('../table/Table.vue')
        },
        {
            path: 'cu',
            name: 'Tạo bộ lọc',
            component: () => import('../cu/CU.vue'),
        },
        {
            path: 'cu/:id',
            name: 'Chỉnh sửa bộ lọc',
            component: () => import('../cu/CU.vue'),
        },
    ]
};